import React, { memo } from "react";
import { useNavigate } from "react-router-dom";

function BankOfferTile({ offer, bankAddress }) {
  const navigate = useNavigate();

  if (!offer) {
    return null;
  }

  return (
    <div
      onClick={() => navigate(`/bankoffer/${offer.bankName}/${offer.id}`)}
      className="border rounded-lg p-4 shadow hover:shadow-lg transition flex flex-col cursor-pointer"
      title="Click to view bank offer details"
    >
      <div className="w-16 h-16 mx-auto mb-2">
        <img
          src={offer.icon || "/default-bank-icon.png"}
          alt={offer.vendor || "Bank Offer"}
          className="w-full h-full object-contain"
        />
      </div>
      <h3 className="font-semibold text-md mb-1 text-center">{offer.vendor && offer.vendor.includes("##") ? offer.category : offer.vendor}</h3>
      {offer.bankName && (
        <p className="text-center text-indigo-600 font-medium mb-2">{offer.bankName}</p>
      )}
      <p className="text-center text-gray-700">{offer.offer}</p>
      {offer.expiryDttm && (
        <p className="text-center text-sm text-gray-500 mt-2">
          Expires: {new Date(offer.expiryDttm.toDate()).toLocaleDateString()}
        </p>
      )}
      {offer.minimumSpend && (
        <p className="text-center text-sm text-gray-600 mt-1">Minimum Spend: ${offer.minimumSpend}</p>
      )}
      {offer.maximumOffer && (
        <p className="text-center text-sm text-gray-600">Max Discount: ${offer.maximumOffer}</p>
      )}
      {bankAddress && (
        <p className="text-center mt-2">
          <a
            href={bankAddress}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
            onClick={(e) => e.stopPropagation()}
          >
            Visit Bank Site
          </a>
        </p>
      )}
    </div>
  );
}

export default memo(BankOfferTile);
